/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExtraIngredientExpense } from '../../models/extra-ingredient-expense';
import { UpdateExtraExpenseDto } from '../../models/update-extra-expense-dto';

export interface ExtraExpensesControllerUpdate$Params {
  id: string;
      body: UpdateExtraExpenseDto
}

export function extraExpensesControllerUpdate(http: HttpClient, rootUrl: string, params: ExtraExpensesControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ExtraIngredientExpense>> {
  const rb = new RequestBuilder(rootUrl, extraExpensesControllerUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExtraIngredientExpense>;
    })
  );
}

extraExpensesControllerUpdate.PATH = '/extra-expenses/{id}';
